import { render, staticRenderFns } from "./CountryStatus.vue?vue&type=template&id=791fa2b2&"
import script from "./CountryStatus.vue?vue&type=script&lang=js&"
export * from "./CountryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports